import {
  GET_PROVIDERS_BIDDINGS,
  GET_PROVIDERS_BIDDINGS_ERROR,
  GET_PROVIDERS_BIDDINGS_SUCCESS,
  GET_PROVIDERS_BIDDINGS_DETAILS,
  GET_PROVIDERS_BIDDINGS_DETAILS_ERROR,
  GET_PROVIDERS_BIDDINGS_DETAILS_SUCCESS,
  GET_PROVIDERS_TRADED_AMOUNTS,
  GET_PROVIDERS_TRADED_AMOUNTS_ERROR,
  GET_PROVIDERS_TRADED_AMOUNTS_SUCCESS,
  GET_PROVIDERS_TRADED_AMOUNTS_DETAILS,
  GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_ERROR,
  GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_SUCCESS
} from './ProvidersByBuyersSection.actions'

const providersByBuyersSectionState = {
  biddings: { csv: [], data: [] },
  biddingsDetails: { data: [], loading: false },
  error: null,
  loading: false,
  tradedAmounts: { csv: [], data: [] },
  tradedAmountsDetails: { data: [], loading: false }
}

/**
 * The providers by buyers section's reducer.
 */
const providersByBuyersSectionReducer = (state = providersByBuyersSectionState, { payload, type }) => {
  switch (type) {
    case GET_PROVIDERS_BIDDINGS:
    case GET_PROVIDERS_TRADED_AMOUNTS: {
      return { ...state, error: providersByBuyersSectionState.error, loading: true }
    }
    case GET_PROVIDERS_BIDDINGS_DETAILS: {
      return {
        ...state,
        biddingsDetails: { ...providersByBuyersSectionState.biddingsDetails, loading: true },
        error: providersByBuyersSectionState.error
      }
    }
    case GET_PROVIDERS_TRADED_AMOUNTS_DETAILS: {
      return {
        ...state,
        error: providersByBuyersSectionState.error,
        tradedAmountsDetails: { ...providersByBuyersSectionState.tradedAmountsDetails, loading: true }
      }
    }
    case GET_PROVIDERS_BIDDINGS_ERROR:
    case GET_PROVIDERS_TRADED_AMOUNTS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PROVIDERS_BIDDINGS_DETAILS_ERROR: {
      return {
        ...state,
        biddingsDetails: { ...state.biddingsDetails, loading: false },
        error: payload.error
      }
    }
    case GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_ERROR: {
      return {
        ...state,
        error: payload.error,
        tradedAmountsDetails: { ...state.tradedAmountsDetails, loading: false }
      }
    }
    case GET_PROVIDERS_BIDDINGS_SUCCESS: {
      return { ...state, biddings: { ...state.biddings, ...payload }, loading: false }
    }
    case GET_PROVIDERS_BIDDINGS_DETAILS_SUCCESS: {
      return {
        ...state,
        biddingsDetails: { ...state.biddingsDetails, ...payload, loading: false }
      }
    }
    case GET_PROVIDERS_TRADED_AMOUNTS_SUCCESS: {
      return { ...state, loading: false, tradedAmounts: { ...state.tradedAmounts, ...payload } }
    }
    case GET_PROVIDERS_TRADED_AMOUNTS_DETAILS_SUCCESS: {
      return {
        ...state,
        tradedAmountsDetails: { ...state.tradedAmountsDetails, ...payload, loading: false }
      }
    }
    default: {
      return state
    }
  }
}

export default providersByBuyersSectionReducer
